import { h, Component } from 'preact';
import ArticleThumb  from 'components/shared/articleThumb/articleThumb';
import HTML from 'components/core/html/html.js';
import s from 'components/shared/grid/grid.sss';


export default class Grid extends Component {

	render(props) {
		const {
			dataObj,
			imageSrc,
			imageRoot,
			title,
			subtitle,
			copy,
			baseConfig
		} = props;
		
		return (
			<div class={s.gridWrapper}>
				{
					imageSrc ? 
						<div>
							<img class={s.image} src={imageSrc} />
							<HTML tag='h1' markdown class={s.title}>{title}</HTML>
						</div>
						:
						<HTML tag='h1' markdown class={s.title}>{title}</HTML>
				}
				{subtitle && <HTML tag='h2' markdown class={s.subtitle}>{subtitle}</HTML>}
				<div class={s.grid}>
					{Object.keys(dataObj).map(data => {
						if (!dataObj[data]) return;
						let finalData = Object.assign({}, baseConfig, dataObj[data]);
						return (
							<ArticleThumb
								copy={copy}
								data={finalData}
								imageRoot={imageRoot}
								title={title}
								thumbClass={s.thumbGrid}
							/>
						);
					})}
				</div>
			</div>
		);
	}

}
